const CONFIG = {
    API_BASE_URL: "https://main-inbound-automation.vercel.app/api/contact",
    BRAND: "naar",
    BRAND_NAME: "NAAR",
    CONTACT_EMAIL: "hello@naarinternational.com",
    SHOP_URL: "https://www.naarofficial.com",
    REVIEW_URL: "https://g.page/r/CY9KauxLa1S2EAI/review",
    REPLACEMENT_FORM_URL: "https://forms.gle/quT6c1JxBS45Ss4w5",
    public: { countries: [] },
};

const contactCountryNameToIso2 = {};

function buildContactCountryNameMap() {
    if (typeof intlTelInput === 'undefined') return;
    const countryData = intlTelInput.getCountryData ? intlTelInput.getCountryData() :
                        (window.intlTelInputGlobals ? window.intlTelInputGlobals.getCountryData() : []);
    countryData.forEach((c) => {
        const cleanName = c.name.replace(/\s*\(.*\)/, '').trim().toLowerCase();
        contactCountryNameToIso2[cleanName] = c.iso2;
        contactCountryNameToIso2[c.name.toLowerCase()] = c.iso2;
    });
    Object.assign(contactCountryNameToIso2, {
        'bolivia': 'bo', 'brunei': 'bn', 'congo': 'cg',
        'democratic republic of the congo': 'cd', 'falkland islands': 'fk',
        'iran': 'ir', 'ivory coast': 'ci', "cote d'ivoire": 'ci',
        'north korea': 'kp', 'south korea': 'kr', 'laos': 'la',
        'libya': 'ly', 'macedonia': 'mk', 'macedonia (fyrom)': 'mk',
        'micronesia': 'fm', 'moldova': 'md', 'palestine': 'ps',
        'russia': 'ru', 'saint helena': 'sh', 'syria': 'sy',
        'taiwan': 'tw', 'tanzania': 'tz', 'venezuela': 've',
        'vietnam': 'vn', 'british virgin islands': 'vg',
        'u.s. virgin islands': 'vi', 'myanmar (burma)': 'mm',
        'türkiye': 'tr', 'east timor': 'tl', 'vatican city': 'va',
        'kosovo': 'xk', 'swaziland': 'sz', 'cape verde': 'cv',
    });
}

function getContactIso2FromCountryName(name) {
    if (!name) return '';
    const lower = name.toLowerCase().trim();
    if (contactCountryNameToIso2[lower]) return contactCountryNameToIso2[lower];
    const keys = Object.keys(contactCountryNameToIso2);
    for (let i = 0; i < keys.length; i++) {
        if (keys[i].indexOf(lower) !== -1 || lower.indexOf(keys[i]) !== -1) {
            return contactCountryNameToIso2[keys[i]];
        }
    }
    return '';
}

const FormManager = {
    state: { userType: null, formData: {} },
    itiInstance: null,

    $(id) {
        const element = document.getElementById(id);
        if (!element) console.warn(`Element with id "${id}" not found`);
        return element;
    },

    show(element) {
        if (typeof element === "string") element = this.$(element);
        if (element) element.classList.remove("d-none");
    },

    hide(element) {
        if (typeof element === "string") element = this.$(element);
        if (element) element.classList.add("d-none");
    },

    validateEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },

    logInfo(message, data = {}) {
        console.log("[INFO]", message, data);
    },

    logWarning(message, data = {}) {
        console.warn("[WARNING]", message, data);
    },

    async logError(error, context = {}) {
        const errorDetails = {
            timestamp: new Date().toISOString(),
            message: error.message,
            stack: error.stack,
            context,
            url: window.location.href,
        };
        console.error("[ERROR]", errorDetails);
    },

    showSpinner(buttonId) {
        const button = this.$(buttonId);
        if (!button) return;
        button.setAttribute("data-original-text", button.innerHTML);
        button.innerHTML = '<span class="spinner-border spinner-border-sm me-2" role="status"></span>Processing...';
        button.disabled = true;
    },

    hideSpinner(buttonId) {
        const button = this.$(buttonId);
        if (!button) return;
        const originalText = button.getAttribute("data-original-text");
        if (originalText) button.innerHTML = originalText;
        button.disabled = false;
    },

    disableForm(disabled = true) {
        const form = this.$("contactForm");
        if (!form) return;
        form.querySelectorAll("input, select, textarea, button").forEach((el) => {
            el.disabled = disabled;
        });
    },

    async fetchConfig() {
        this.logInfo("Fetching configuration");
        try {
            const response = await fetch(CONFIG.API_BASE_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    action: "get_config",
                    brand: CONFIG.BRAND,
                    origin: window.location.origin,
                }),
            });

            const data = await response.json();
            if (!data.success || !data.config) {
                throw new Error("Invalid configuration received: " + JSON.stringify(data));
            }

            CONFIG.public = data.config;
            this.logInfo("Configuration loaded successfully");
            return true;
        } catch (error) {
            await this.logError(error, { function: "fetchConfig" });
            return false;
        }
    },

    init() {
        this.fetchConfig()
            .then((loaded) => {
                if (loaded) {
                    try {
                        this.setupCountryDropdown();
                        this.initIntlTelInput();
                        this.setupEventListeners();
                        this.setupIframeHeightUpdates();
                        this.logInfo("Form initialization completed successfully");
                    } catch (error) {
                        this.logError(error, { function: "init" });
                    }
                } else {
                    this.logError(new Error("Configuration load failed"));
                    alert(`Failed to load contact form. Please email us at ${CONFIG.CONTACT_EMAIL}`);
                }
            })
            .catch((error) => {
                this.logError(error, { function: "init" });
                alert(`Failed to load contact form. Please email us at ${CONFIG.CONTACT_EMAIL}`);
            });
    },

    setupCountryDropdown() {
        const countrySelect = this.$("country");
        if (!countrySelect) return;

        const allCountries = [
        "Afghanistan",
        "Albania",
        "Antarctica",
        "Åland Islands",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antigua and Barbuda",
        "Aruba",
        "Asia/Pacific Region",
        "Azerbaijan",
        "Argentina",
        "Armenia",
        "Australia",
        "Austria",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belgium",
        "Bhutan",
        "Bolivia",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Brazil",
        "Caribbean Netherlands",
        "Belize",
        "Solomon Islands",
        "Brunei",
        "Bulgaria",
        "Burundi",
        "Belarus",
        "Bermuda",
        "Cambodia",
        "Cayman Islands",
        "Cameroon",
        "Canada",
        "Cape Verde",
        "Central African Republic",
        "Cuba",
        "Curaçao",
        "Sri Lanka",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos (Keeling) Islands",
        "Colombia",
        "Comoros",
        "Congo",
        "Democratic Republic of the Congo",
        "Cook Islands",
        "Costa Rica",
        "Croatia",
        "Cyprus",
        "Czech Republic",
        "Benin",
        "Denmark",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "El Salvador",
        "Equatorial Guinea",
        "Ethiopia",
        "Eritrea",
        "Estonia",
        "Europe",
        "South Georgia and the South Sandwich Islands",
        "Fiji",
        "Finland",
        "France",
        "Falkland Islands",
        "Faroe Islands",
        "French Polynesia",
        "French Southern and Antarctic Lands",
        "Djibouti",
        "Gabon",
        "Georgia",
        "Gambia",
        "Germany",
        "Ghana",
        "Greenland",
        "Guadeloupe",
        "Guernsey",
        "Kiribati",
        "Greece",
        "Grenada",
        "Guam",
        "Guatemala",
        "Guinea",
        "Guyana",
        "French Guiana",
        "Gibraltar",
        "Haiti",
        "Heard Island and McDonald Islands",
        "Vatican City",
        "Honduras",
        "Hungary",
        "Hong Kong",
        "Isle of Man",
        "Iran",
        "Jersey",
        "Macau",
        "Martinique",
        "Montserrat",
        "Myanmar (Burma)",
        "North Korea",
        "Palestine",
        "Puerto Rico",
        "Réunion",
        "Saint Barthélemy",
        "Saint Martin",
        "Sint Maarten",
        "South Sudan",
        "Sudan",
        "Syria",
        "Taiwan",
        "Turks and Caicos Islands",
        "U.S. Virgin Islands",
        "Iceland",
        "India",
        "Indonesia",
        "Iraq",
        "Ireland",
        "Israel",
        "Italy",
        "British Indian Ocean Territory",
        "Cote d'Ivoire",
        "Jamaica",
        "Japan",
        "Kazakhstan",
        "Jordan",
        "Kenya",
        "South Korea",
        "Kosovo",
        "Kuwait",
        "Kyrgyzstan",
        "Laos",
        "Lebanon",
        "Lesotho",
        "Latvia",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Monaco",
        "Mongolia",
        "Moldova",
        "Montenegro",
        "Morocco",
        "Mozambique",
        "Oman",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "New Caledonia",
        "Vanuatu",
        "Netherlands Antilles",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Niue",
        "Norfolk Island",
        "Norway",
        "Northern Mariana Islands",
        "United States Minor Outlying Islands",
        "Micronesia",
        "Marshall Islands",
        "Palau",
        "Pakistan",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Pitcairn Islands",
        "Poland",
        "Portugal",
        "Guinea-Bissau",
        "East Timor",
        "Qatar",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Helena",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Pierre and Miquelon",
        "Saint Vincent and the Grenadines",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Svalbard and Jan Mayen",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Vietnam",
        "Western Sahara",
        "Slovenia",
        "Somalia",
        "South Africa",
        "Zimbabwe",
        "Spain",
        "Suriname",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Tajikistan",
        "Thailand",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad and Tobago",
        "United Arab Emirates",
        "Tunisia",
        "Türkiye",
        "Turkmenistan",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "Macedonia (FYROM)",
        "Egypt",
        "United Kingdom",
        "Tanzania",
        "United States",
        "Burkina Faso",
        "Uruguay",
        "Uzbekistan",
        "Venezuela",
        "British Virgin Islands",
        "Wallis and Futuna",
        "Samoa",
        "Yemen",
        "Zambia",
        "Canary Islands"
        ];

        allCountries.sort((a, b) =>
            a.localeCompare(b, undefined, { sensitivity: "base" })
        );

        allCountries.forEach((country) => {
            const option = document.createElement("option");
            option.value = country;
            option.textContent = country;
            countrySelect.appendChild(option);
        });

        this.logInfo("Country dropdown populated");
    },

    initIntlTelInput() {
        if (typeof intlTelInput === 'undefined') return;
        buildContactCountryNameMap();

        const phoneInput = this.$('phone');
        if (!phoneInput) return;

        this.itiInstance = intlTelInput(phoneInput, {
            initialCountry: 'auto',
            geoIpLookup: (successCallback) => {
                fetch('https://ipapi.co/json/')
                    .then((resp) => resp.json())
                    .then((data) => successCallback((data && data.country) ? data.country : 'us'))
                    .catch(() => successCallback('us'));
            },
            utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@24.7.0/build/js/utils.js',
            nationalMode: true,
            formatOnDisplay: true,
            autoPlaceholder: 'aggressive',
        });

        // Capture wheel events on the country list before anything else can
        // handle them. Manually scroll the list, block everything else.
        document.addEventListener('wheel', function(e) {
            var list = e.target.closest('.iti__country-list');
            if (!list) return;
            list.scrollTop += e.deltaY;
            e.preventDefault();
            e.stopPropagation();
        }, { passive: false, capture: true });

        // Phone flag → Country dropdown sync
        phoneInput.addEventListener('countrychange', () => {
            const selectedData = this.itiInstance.getSelectedCountryData();
            if (!selectedData || !selectedData.iso2) return;
            const countrySelect = this.$('country');
            if (!countrySelect) return;
            for (let i = 0; i < countrySelect.options.length; i++) {
                if (getContactIso2FromCountryName(countrySelect.options[i].value) === selectedData.iso2) {
                    countrySelect.value = countrySelect.options[i].value;
                    countrySelect.classList.remove('is-invalid');
                    break;
                }
            }
        });

        // Country dropdown → Phone flag sync
        const countrySelect = this.$('country');
        if (countrySelect) {
            countrySelect.addEventListener('change', () => {
                const iso2 = getContactIso2FromCountryName(countrySelect.value);
                if (iso2 && this.itiInstance) {
                    this.itiInstance.setCountry(iso2);
                }
            });
        }

        // Real-time phone validation
        phoneInput.addEventListener('blur', () => this.validatePhoneField());
        phoneInput.addEventListener('input', () => {
            if (phoneInput.classList.contains('is-invalid')) this.validatePhoneField();
        });
    },

    validatePhoneField() {
        const phoneInput = this.$('phone');
        const phoneError = phoneInput?.parentElement?.querySelector('.contact-phone-error');
        const value = phoneInput?.value?.trim();

        // Phone is optional on contact form — skip validation if empty
        if (!value) {
            phoneInput.classList.remove('is-invalid');
            if (phoneError) phoneError.style.display = 'none';
            return true;
        }

        if (this.itiInstance && !this.itiInstance.isValidNumber()) {
            phoneInput.classList.add('is-invalid');
            if (phoneError) { phoneError.textContent = 'Please enter a valid phone number'; phoneError.style.display = 'block'; }
            return false;
        }

        phoneInput.classList.remove('is-invalid');
        if (phoneError) phoneError.style.display = 'none';
        return true;
    },

    setupEventListeners() {
        document.querySelectorAll('input[name="userType"]').forEach((radio) => {
            radio.addEventListener("change", (e) => {
                this.state.userType = e.target.value;
                // Clear radio error styling on selection
                document.querySelectorAll('input[name="userType"]').forEach((r) => {
                    const label = r.nextElementSibling || document.querySelector(`label[for="${r.id}"]`);
                    if (label) label.style.color = '';
                });
                this.updateStep1UI();
            });
        });

        this.$("step1NextButton")?.addEventListener("click", () => this.handleStep1Next());

        // Clear is-invalid on input/change for all form fields (except phone, handled by intl-tel-input)
        const contactForm = this.$("contactForm");
        if (contactForm) {
            contactForm.querySelectorAll("input, select, textarea").forEach((field) => {
                if (field.type === 'tel') return;
                const event = (field.tagName === 'SELECT') ? 'change' : 'input';
                field.addEventListener(event, () => {
                    if (field.classList.contains('is-invalid') && field.value?.trim()) {
                        field.classList.remove('is-invalid');
                    }
                });
            });
        }

        ["consumerSubject", "distributorHelpType", "shopHelpType"].forEach((id) => {
            this.$(id)?.addEventListener("change", (e) => {
                const messageSection = this.$("messageSection");
                const messageInput = this.$("message");
                if (e.target.value === "Other") {
                    this.show(messageSection);
                    messageInput.required = true;
                    messageInput.disabled = false;
                } else if (this.state.userType !== "Other") {
                    this.hide(messageSection);
                    messageInput.required = false;
                    messageInput.disabled = true;
                }
            });
        });

        this.$("step2NextButton")?.addEventListener("click", () => this.handleStep2Next());

        this.$("submitButton")?.addEventListener("click", (e) => {
            e.preventDefault();
            this.handleFinalSubmission("step2");
        });

        this.$("step3SubmitButton")?.addEventListener("click", (e) => {
            e.preventDefault();
            this.handleFinalSubmission("step3");
        });

        document.body.addEventListener("click", (e) => {
            if (e.target.closest("#consumerResponses") && e.target.tagName === "BUTTON") {
                e.preventDefault();
                this.hide("consumerResponses");
                this.showThankYou();
            }
        });
    },

    updateStep1UI() {
        if (this.state.userType === "Other") {
            this.show("otherUserTypeSpecific");
            this.$("otherType").required = true;
        } else {
            this.hide("otherUserTypeSpecific");
            this.$("otherType").required = false;
        }
    },

    updateStep2UI() {
        const { userType } = this.state;

        const manageSection = (sectionId, showSection) => {
            const section = this.$(sectionId);
            if (!section) return;
            if (showSection) {
                this.show(section);
                section.querySelectorAll("input, select, textarea").forEach((el) => (el.disabled = false));
            } else {
                this.hide(section);
                section.querySelectorAll("input, select, textarea").forEach((el) => (el.disabled = true));
            }
        };

        const isDistributor = userType === "Distributor/Wholesaler";
        const isShop = userType === "Shop/Retailer";
        const isConsumer = userType === "Consumer";
        const isOther = userType === "Other";

        manageSection("companyInfo", isDistributor || isShop || isOther);
        manageSection("shopSpecificFields", isShop);
        manageSection("consumerHelpSection", isConsumer);
        manageSection("distributorHelpSection", isDistributor);
        manageSection("shopHelpSection", isShop);

        if (isOther) {
            manageSection("messageSection", true);
            this.$("message").required = true;
        } else {
            manageSection("messageSection", false);
            this.$("message").required = false;
        }

        const companyNameLabel = document.querySelector('label[for="companyName"]');
        if (companyNameLabel) {
            if (isDistributor || isShop) {
                companyNameLabel.classList.add("required-field");
            } else {
                companyNameLabel.classList.remove("required-field");
            }
        }

        if (isDistributor || isShop) {
            this.show("step2NextButton");
            this.hide("submitButton");
        } else {
            this.hide("step2NextButton");
            this.show("submitButton");
        }
    },

    updateStep3UI() {
        const { userType } = this.state;
        if (userType === "Distributor/Wholesaler") {
            this.show("distributorBusinessModel");
            this.hide("shopBusinessModel");
        } else if (userType === "Shop/Retailer") {
            this.hide("distributorBusinessModel");
            this.show("shopBusinessModel");
        }
    },

    goToStep(step) {
        this.hide("step1");
        this.hide("step2");
        this.hide("step3");
        this.hide("thankYou");
        this.hide("consumerResponses");
        if (typeof step === "number") {
            this.show(`step${step}`);
        } else {
            this.show(step);
        }
    },

    handleStep1Next() {
        const selectedRadio = document.querySelector('input[name="userType"]:checked');
        if (!selectedRadio) {
            // Highlight all radio labels to indicate selection is required
            document.querySelectorAll('input[name="userType"]').forEach((r) => {
                const label = r.nextElementSibling || document.querySelector(`label[for="${r.id}"]`);
                if (label) label.style.color = 'var(--bs-form-invalid-border-color, #dc3545)';
            });
            return;
        }

        // Clear radio error styling
        document.querySelectorAll('input[name="userType"]').forEach((r) => {
            const label = r.nextElementSibling || document.querySelector(`label[for="${r.id}"]`);
            if (label) label.style.color = '';
        });

        this.state.userType = selectedRadio.value;

        if (this.state.userType === "Other" && !this.$("otherType").value) {
            this.$("otherType").classList.add("is-invalid");
            this.$("otherType").focus();
            return;
        }

        this.$("otherType").classList.remove("is-invalid");
        this.logInfo("Moving to step 2", { userType: this.state.userType });
        this.goToStep(2);
        this.updateStep2UI();
    },

    handleStep2Next() {
        if (!this.validateStep(2)) return;
        this.collectStepData(2);
        this.logInfo("Moving to step 3", { formData: this.state.formData });
        this.goToStep(3);
        this.updateStep3UI();
    },

    async handleFinalSubmission(fromStep) {
        const stepNum = fromStep === "step2" ? 2 : 3;
        if (!this.validateStep(stepNum)) return;

        this.collectStepData(stepNum);
        const buttonId = stepNum === 2 ? "submitButton" : "step3SubmitButton";

        this.showSpinner(buttonId);
        this.disableForm(true);

        try {
            this.logInfo("Submitting final form data", { formData: this.state.formData });

            const response = await fetch(CONFIG.API_BASE_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    brand: CONFIG.BRAND,
                    ...this.state.formData,
                }),
            });

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result.message || "An unknown error occurred during submission.");
            }

            if (this.state.userType === "Consumer") {
                this.handleConsumerResponse(result.consumerResponse);
            } else {
                this.showThankYou();
            }
        } catch (error) {
            this.logError(error, {
                function: "handleFinalSubmission",
                formData: this.state.formData,
            });
            alert(`There was an error submitting your form. Please email us at ${CONFIG.CONTACT_EMAIL}`);
        } finally {
            this.hideSpinner(buttonId);
            this.disableForm(false);
        }
    },

    handleConsumerResponse(responseHtml) {
        const subject = this.state.formData.subject;
        this.logInfo("Handling consumer response", { subject });

        if (responseHtml) {
            this.goToStep("consumerResponses");
            const responsesDiv = this.$("consumerResponses");
            if (responsesDiv) {
                responsesDiv.innerHTML = `
                    <div class="col-12">
                        <div class="response-panel">
                            ${responseHtml}
                        </div>
                    </div>
                    <div class="col-12">
                            <button type="button" class="btn btn-primary mt-3">Done</button>
                    </div>
                `;
            }
        } else {
            this.showThankYou();
        }
    },

    showThankYou() {
        this.goToStep("thankYou");
        const country = this.state.formData.country;
        const userType = this.state.userType;

        if (country === "United States" && (userType === "Distributor/Wholesaler" || userType === "Shop/Retailer")) {
            this.show("shopLink");
        } else {
            this.hide("shopLink");
        }
    },

    validateStep(stepNumber) {
        let isValid = true;
        let firstInvalidField = null;
        const invalidLabels = [];

        const requiredFields = {
            2: [
                { id: "firstName", label: "First Name" },
                { id: "lastName", label: "Last Name" },
                { id: "country", label: "Country" },
                { id: "email", label: "Email" },
                { id: "hearAboutUs", label: "How did you hear about us?" },
            ],
            3: [],
        };

        const userType = this.state.userType;

        if (stepNumber === 2) {
            if (userType === "Distributor/Wholesaler" || userType === "Shop/Retailer") {
                requiredFields[2].push({ id: "companyName", label: "Company Name" });
            }
            if (userType === "Shop/Retailer") {
                requiredFields[2].push({ id: "shopLocations", label: "Number of locations" });
            }
            if (userType === "Consumer") {
                requiredFields[2].push({ id: "consumerSubject", label: "How can we help you?" });
            }
            if (userType === "Distributor/Wholesaler") {
                requiredFields[2].push({ id: "distributorHelpType", label: "How can we help you?" });
            }
            if (userType === "Shop/Retailer") {
                requiredFields[2].push({ id: "shopHelpType", label: "How can we help you?" });
            }
            if (this.$("message").required) {
                requiredFields[2].push({ id: "message", label: "Message" });
            }
        }

        (requiredFields[stepNumber] || []).forEach(({ id, label }) => {
            const field = this.$(id);
            if (field && !field.disabled) {
                field.classList.remove("is-invalid");
                if (!field.value?.trim()) {
                    isValid = false;
                    field.classList.add("is-invalid");
                    if (!firstInvalidField) firstInvalidField = field;
                    invalidLabels.push(label);
                }
            }
        });

        const emailField = this.$("email");
        if (emailField && !emailField.disabled && emailField.value && !this.validateEmail(emailField.value)) {
            isValid = false;
            emailField.classList.add("is-invalid");
            if (!firstInvalidField) firstInvalidField = emailField;
            invalidLabels.push("a valid Email");
        }

        // Phone validation (optional field, but validate if filled)
        if (stepNumber === 2 && !this.validatePhoneField()) {
            isValid = false;
            const phoneField = this.$("phone");
            if (!firstInvalidField) firstInvalidField = phoneField;
            invalidLabels.push("a valid Phone number");
        }

        if (!isValid) {
            firstInvalidField?.focus();
            this.logWarning("Validation failed", { step: stepNumber, invalidLabels });
        }

        return isValid;
    },

    collectStepData(stepNumber) {
        const stepContainer = this.$(`step${stepNumber}`);
        if (!stepContainer) return;

        const inputs = stepContainer.querySelectorAll("input, select, textarea");
        const stepData = {};

        inputs.forEach((input) => {
            if (input.disabled || !input.name) return;

            if (input.type === "checkbox") {
                if (!stepData[input.name]) stepData[input.name] = [];
                if (input.checked) stepData[input.name].push(input.value);
            } else if (input.type === "radio") {
                if (input.checked) stepData[input.name] = input.value;
            } else {
                stepData[input.name] = input.value;
            }
        });

        Object.keys(stepData).forEach((key) => {
            if (Array.isArray(stepData[key])) {
                stepData[key] = stepData[key].join("; ");
            }
        });

        this.state.formData = { ...this.state.formData, ...stepData };
        this.state.formData.userType = this.state.userType;

        // Use E.164 format for phone number
        if (stepData.phone !== undefined && this.itiInstance) {
            this.state.formData.phone = this.itiInstance.getNumber() || stepData.phone;
        }

        if (this.state.userType === "Other") {
            this.state.formData.otherType = this.$("otherType").value;
        }
    },

    setupIframeHeightUpdates() {
        if (window.self === window.top) return;

        const sendHeight = () => {
            setTimeout(() => {
                const height = document.documentElement?.scrollHeight || document.body?.scrollHeight || 0;
                if (height > 0) {
                    window.parent.postMessage({ frameHeight: height }, "*");
                }
            }, 50);
        };

        ["load", "resize"].forEach((event) => window.addEventListener(event, sendHeight));
        new MutationObserver(sendHeight).observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
        });
        sendHeight();
    },
};

document.addEventListener("DOMContentLoaded", () => FormManager.init());
